import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { GLOSASCONTABILIDAD_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function AsientosContablesPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${GLOSASCONTABILIDAD_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
